<template>
  <div class="details-container" v-loading="loading">
    <div class="f-e-c f">
      <el-button type="text" @click="$refs.refundLog.show(orders.kkOrderId)">退款记录</el-button>
      <!-- <el-button type="text" v-if="['waiting_to_ship', 'partial_shipped'].includes(showStatus) && !(detailObj.pays.paymentMethod === 8 && detailObj.orders.fulfillmentStatus === 'partial_shipped')" @click="handleRefund">退款</el-button> -->
      <el-button type="text" v-if="['waiting_to_ship', 'partial_shipped'].includes(showStatus) && detailObj.pays.paymentMethod !== 8" @click="handleRefund">退款</el-button>
    </div>
    <!-- <div class="header">
    </div> -->
    <div class="refund_reason bg-white f-b" v-if="detailObj.orders.refundStatus !== 'NULL'">
      <div style="color: #EB5757">
        <h3 style="font-size: 18px">{{ refundText }}</h3>
        <p v-if="detailObj.orders.refundReason" style="color: #4F4F4F">{{ `Refund Reason: ${detailObj.orders.refundReason || 'Refund Reason:显示的是用户提交的退款原因'}` }}</p>
      </div>
      <div>
        <el-button type="text" style="height: 44px;font-size: 16px" round @click="$refs.refundRecord.show(detailObj.orders.kkOrderId)">Refund Record</el-button>
      </div>
    </div>
    <timeLineItemVue :detailObj="detailObj"></timeLineItemVue>
    <div class="summary">
      <span>Order ID：{{ defaultTips(orders.kkOrderId) }}</span>
      <span>Email/Phone Number：{{ defaultTips(orders.showName) }}</span>
      <span>Source：{{ defaultTips(orders.storeName) }}</span>
      <span>Store Order ID：{{ defaultTips(orders.storeOrderId) }}</span>
      <span>Shipping Method：{{ defaultTips(orders.channelLevel) }}</span>
      <span class="income-statement" @click="incomeStatement">Income statement</span>
    </div>

    <div class="subject">
      <!-- 物流商品信息 -->
      <div class="left bg-white">
        <div class="productItemGroup" v-for="(item, index) in detailObj.orderLogistics" :key="index">
          <template v-if="item.omsPackId">
            <div class="shipping_soon" v-if="showStatus === 'waiting_to_ship'">
              <h3 style="margin-bottom: 16px">Not deliver yet</h3>
              <div class="info f" style="margin-bottom: 16px">
                <div class="code">Parcel Code: {{ item.omsPackId }}</div>
                <div class="packStatus f--c">{{ item.packStatus }}</div>
              </div>
            </div>
            <div class="shippedInfomation" v-else>
              <div class="f-b" style="margin-bottom: 16px">
                <h4 style="line-height: 36px">Logistics Information</h4>
                <el-button type="primary" round v-if="!['Cancelled', 'Completed'].includes(item.packStatus)" @click="confirmReceipt(item)">Confirm Receipt</el-button>
                <div class="packStatis_complete" v-else>Completed</div>
              </div>
              <div class="f--c" style="margin-bottom: 16px">
                <div style="color: #747A87;flex: 1">Delivery time: {{ getMoment(item.deliveryDate).format('YYYY-MM-DD HH:mm:ss') }}</div>
                <div style="color: #99c41c;flex: 1">
                  <div v-if="item.trackingCode">Tracking code: {{ item.trackingCode }}</div>
                  <div v-if="item.tailTrackingCode">Tail Tracking code: {{ item.tailTrackingCode }}</div>
                </div>
                <div style="color: #747A87;flex: 1">Logistics providers: {{ item.logisticsProviders }}</div>
              </div>
              <div class="f" style="margin-bottom: 16px">
                <div style="color: #747A87">Parcel Code: {{ item.omsPackId }}</div>
                <div class="f--c packStatus">{{ item.packStatus }}</div>
              </div>
            </div>
          </template>
          <template v-for="product in item.items">
            <div v-if="product.type !== 'Cards'" class="productItem f-b" :key="product.skuCode">
              <div style="width: calc(100% - 200px);">
                <div class="f" style="margin-bottom: 8px; font-size: 13px; color: #747a87">
                  <div style="margin-right: 8px">SKU：{{ product.skuCode }}</div>
                  <el-popover v-if="product.attachmentSkuVos && product.attachmentSkuVos.length && product.attachmentSkuVos.filter(t => t.type !== 'Cards').length" placement="bottom" width="360" trigger="hover">
                    <div class="partsTable">
                      <p>Accessories</p>
                      <template v-for="item in product.attachmentSkuVos">
                        <div v-if="item.type !== 'Cards'" :key="item.type+`_${item.id}`" class="f productBox">
                          <div class="imageBox">
                            <el-image :src="item.imageUrl" style="height: 52px; width: 52px"></el-image>
                          </div>
                          <div class="f-b fd-c info">
                            <p>{{ item.name }}</p>
                            <p>x {{ product.productNum }}</p>
                          </div>
                        </div>
                      </template>
                    </div>
                    <i class="icon-pinpaitemai-tianchong iconfont myAttachemtIcon" style="color: #99c41c; margin-right: 8px" slot="reference"></i>
                  </el-popover>
                  <div v-if="product.sellerSku && detailObj.orders.platformCode !== 'KA'">Store SKU：{{ product.sellerSku }}</div>
                </div>
                <div class="f">
                  <div style="margin-right: 10px">
                    <el-popover placement="right" width="280" trigger="hover">
                      <el-image fit="cover" :src="product.imageUrl"></el-image>
                      <div style="position: relative; width: 70px; height: 70px; border-radius: 6px" slot="reference">
                        <el-image style="width: 70px; height: 70px; border-radius: 6px" :src="product.imageUrl" slot="reference"></el-image>
                        <div v-if="product.productType === 3"
                          style="position: absolute;
                          bottom: 8px;
                          background-color: #F7FCEB;
                          width: 100%;
                          height: 16px;
                          font-size: 12px;
                          line-height: 16px;
                          text-align:center;
                          color: #9AC331;">POD</div>
                        <div v-if="(product.isOutOfStock === 1 && !item.trackingCode) || (['waiting_payment','abnormal_order'].includes(detailObj.orders.status) && product.skuStatus !== 1)" class="f-c-c" style="width: 70px; height: 70px; position: absolute; left: 0; top: 0; background: rgba(0, 0, 0, 0.37); border-radius: 6px; color: #f2f2f2; font-size: 12px">Sold Out</div>
                      </div>
                    </el-popover>
                  </div>
                  <div class="skuInfo">
                    <el-tooltip effect="dark" :content="product.productName" placement="top">
                      <div class="ellipsis" style="width: 300px; margin-bottom: 4px">{{ product.productName }}</div>
                    </el-tooltip>
                    <p v-if="product.options && product.options.length" style="margin-bottom: 4px">{{ options(product.options) }}</p>
                    <p v-else style="margin-bottom: 4px">-</p>
                    <div>
                      <span>US ${{ product.finalAmount }}</span>
                      <span v-if="product.price !== product.finalAmount" style="color: #747a87; font-size: 12px; text-decoration: line-through">${{ product.price }}</span>
                    </div>
                  </div>
                  <div class="itemPrice f-c-c">
                    <span style="font-size: 14px; margin-right: 14px">X {{ product.productNum }}</span>
                    <span style="font-size: 16px">$ {{ (product.finalAmount * product.productNum).toFixed(2) }}</span>
                  </div>
                </div>
              </div>
              <!-- <div v-if="product.refundStatus !== 'NULL'" class="f f-e" style="flex: 1">
                <div class="refundStatus f--c" style="height: 14px;margin-top: 18px">{{ refundTextMap[product.refundStatus] }}</div>
              </div> -->
              <div class="f fd-c" style="align-items: flex-end;flex-shrink:0;">
                <div style="padding-top: 6px;font-size:16px">{{ product.countryName }}</div>
                <div v-if="product.refundStatus !== 'NULL'" class="refundStatus f--c" style="height: 14px;margin-top: 18px">{{ refundTextMap[product.refundStatus] }}</div>
              </div>
            </div>
          </template>
          <!-- 好评卡 -->
          <template v-if="item.items.some(t => t.type === 'Cards')">
            <div v-for="product in item.items.filter(t => t.type === 'Cards')" class="productItem f-b" :key="product.skuCode">
              <div style="width: calc(100% - 200px);">
                <div class="f" style="margin-bottom: 8px; font-size: 13px; color: #747a87">
                  <div style="margin-right: 8px">SKU：{{ product.skuCode }}</div>
                </div>
                <div class="f">
                  <div style="margin-right: 10px">
                    <el-popover placement="right" width="280" trigger="hover">
                      <el-image fit="cover" :src="product.imageUrl"></el-image>
                      <div style="position: relative; width: 70px; height: 70px; border-radius: 6px" slot="reference">
                        <el-image style="width: 70px; height: 70px; border-radius: 6px" :src="product.imageUrl" slot="reference"></el-image>
                      </div>
                    </el-popover>
                  </div>
                  <div class="skuInfo">
                    <el-tooltip effect="dark" :content="product.productName" placement="top">
                      <div class="ellipsis" style="width: 300px; margin-bottom: 4px">{{ product.productName }}</div>
                    </el-tooltip>
                    <div>$0</div>
                  </div>
                  <div class="itemPrice f-c-c">
                    <span style="font-size: 14px; margin-right: 14px">X 1</span>
                  </div>
                </div>
              </div>
            </div>
          </template>
          <div class="f-e weightTotal" style="line-height: 70px">
            <span>Weight:</span>
            <span>{{ packageWeight(item.items) }}g</span>
          </div>
        </div>
      </div>
      <!-- 备注/订单状态/收货地址 -->
      <div class="right">
        <div class="remark">
          <p class="remark-describe">
            <strong>Remark</strong>
          </p>
          <p class="remark-text">{{ orders.remark }}</p>
        </div>

        <div class="order-status">
          <!-- <p class="status">
            <strong>Order status</strong>
          </p> -->
          <p class="balance">{{ orderStatus }}</p>
          <h3 style="margin-bottom: 20px;font-size: 18px">Payment Information</h3>
          <h5 style="margin-bottom: 22px;font-size: 16px" v-if="['abnormal_order', 'waiting_payment', 'cancel'].includes(detailObj.orders.status)">{{ `-` }}</h5>
          <h5 style="margin-bottom: 22px;font-size: 16px" v-else class="f--c">
            {{ `${paymentMethodObjInternational} payment` }}
            <img class="pay-icon" src="@/assets/paypal.png" v-if="+pays.paymentMethod === 2" style="height:22px" />
            <!-- <span v-else-if="+pays.paymentMethod === 3" style="margin-left: 4px">Airwallex</span> -->
          </h5>
          <div class="payment">
            <span class="payment-left">Transaction ID</span>
            <span class="payment-right">{{ pays.transactionId }}</span>
          </div>
          <div class="payment">
            <span class="payment-left">Payment ID</span>
            <span class="payment-right">{{ pays.paymentId }}</span>
          </div>
          <div class="payment">
            <span class="payment-left">Payment Time</span>
            <span class="payment-right">{{ formatDate(times.payDate) }}</span>
          </div>
          <div class="payment">
            <span class="payment-left">Item Subtotal</span>
            <span class="payment-right">{{ `USD${defaultTips(pays.skusAmount)}` }}</span>
          </div>
          <div class="payment">
            <span class="payment-left">Shipping Fee</span>
            <span class="payment-right">{{ `USD${pays.freightAmount}` }}</span>
          </div>
          <div class="payment">
            <span class="payment-left">Discount</span>
            <span class="payment-right" :style="{ color: pays.discountAmount ? '#EB5757' : '#333' }">- US{{ `${pays.discountAmount}` }}</span>
          </div>

          <!-- 优惠码 -->
          <div class="payment promo">
            <span class="payment-left">
              <span>Promo code</span>
              <el-popover placement="bottom" trigger="hover">
                <p class="used-tips">{{ `Promo Code: ${promoCode.couponCode}` }}</p>
                <div class="choose-to-use">
                  <i class="el-icon-s-ticket" />
                  <span class="get-info">
                    <strong class="get">{{ getOfferDisplayText }}</strong>
                    <span class="discount">{{ `${promoCode.discountRule === 1 ? `${promoCode.discountPercent && promoCode.discountPercent.toFixed(2)}% off` : `$${promoCode.discountFixed && promoCode.discountFixed.toFixed(2)}`}` }}</span>
                  </span>
                </div>
                <i v-show="promoCode.couponCode" slot="reference" class="el-icon-s-ticket" />
              </el-popover>
            </span>
            <span class="payment-right" :style="{ color: pays.couponAmount ? '#EB5757' : '#333' }">- US${{ pays.couponAmount }}</span>
          </div>

          <!-- 优惠券 -->
          <div class="payment promo">
            <span class="payment-left">
              <span>Coupon</span>
              <el-popover placement="bottom" trigger="hover">
                <p class="used-tips">{{ `${coupon.id ? 1 : 0} coupon used` }}</p>
                <CouponItem :coupon="coupon" isDetails class="coupon-item" />
                <i v-show="coupon.id" slot="reference" class="el-icon-s-ticket" />
              </el-popover>
            </span>
            <span class="payment-right" :style="{ color: pays.couponTicketAmount ? '#EB5757' : '#333' }">- US${{ pays.couponTicketAmount }}</span>
          </div>

          <div class="payment">
            <span class="payment-left">Payment Amount</span>
            <span class="payment-right">USD{{ pays.finalAmount }}</span>
          </div>
        </div>

        <div class="shipping-address">
          <p class="shipping">
            <strong>Shipping Address</strong>
          </p>
          <div>
            <p>{{ address.country }}</p>
            <p>{{ address.city }}</p>
            <p>{{ address.phone }}</p>
            <p>{{ address.recipient }}</p>
            <p>{{ address.street1 }}</p>
            <p>{{ address.street2 }}</p>
            <p>{{ address.province }}</p>
            <p>{{ address.zip }}</p>
            <p>{{ address.vat }}</p>
            <p>{{ address.ioss }}</p>
          </div>
        </div>
      </div>
    </div>
    <!-- 利润表 -->
    <el-dialog title="Income statement" :visible.sync="dialogVisible" width="68%" :before-close="closeDialog">
      <template>
        <el-table :data="tableData" style="width: 100%">
          <el-table-column label="Product" width="320">
            <template slot-scope="{ row }">
              <div class="image">
                <span class="image-item">
                  <el-popover placement="right" width="280" trigger="hover">
                    <el-image :src="row.sizeImagePath" fit="cover" />
                    <el-image slot="reference" :src="row.sizeImagePath" fit="cover" />
                  </el-popover>
                </span>
                <div class="options">
                  <p class="ellipsis2" :title="row.productName">{{ row.productName }}</p>
                  <p class="ellipsis" :title="row.options">{{ options(row.options) }}</p>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="skuCode" label="SKU" />
          <el-table-column prop="purchasePrices" label="Purchase prices" />
          <el-table-column prop="price" label="Price" />
          <el-table-column prop="productNum" label="Quantity" />
          <el-table-column prop="subtotal" label="Subtotal" />
          <el-table-column prop="profit" label="Profi" />
        </el-table>
      </template>
    </el-dialog>
    <RefundLog ref="refundLog"></RefundLog>
    <trackingDialog ref="trackingDialog"></trackingDialog>
  </div>
</template>

<script>
import API from '@/api'
import RefundLog from './RefundLog.vue'
import moment from 'moment'
import _ from 'lodash'
import trackingDialog from './trackingDialog.vue'
import timeLineItemVue from './topTimeLine.vue'

import CouponItem from '@/components/CouponItem.vue'

export default {
  components: {
    RefundLog,
    trackingDialog,
    timeLineItemVue,

    CouponItem
  },
  props: {
    // orderDetailsId: { // 从路由来
    //   type: [String, Number],
    //   require: true
    // }
  },
  data() {
    return {
      loading: false,
      active: 1, // 当前激活的步骤
      dialogVisible: false,
      moment: moment, // 处理日期插件
      times: {},
      address: {},
      orders: {},
      pays: {},
      orderLogistics: [],
      tableData: [],
      stepList: [],
      stepTitle: '',
      orderStatusText: '',
      orderStatus: '',

      coupon: {}, // 优惠券

      promoCode: {} // 优惠码
    }
  },
  computed: {
    getOfferDisplayText() {
      switch (this.promoCode.discountCondition) {
        case 0: // 无门槛
          return `Get `
        case 1: // 消费满件数
          return `Spend `
        case 2: // 消费满金额
          return `Get `
        default:
          return '-'
      }
    },
    options() {
      return (options) => {
        let value = []
        JSON.parse(options) &&
          JSON.parse(options).forEach((item) => {
            value.push(JSON.parse(item).value)
          })
        return value.join('、')
      }
    },
    formatDate() {
      return (date) => {
        if (!date) return '-'
        return moment(date).format('YYYY-MM-DD HH:mm:ss')
      }
    },
    defaultTips() {
      return (value) => value || '-'
    },
    paymentMethodObjInternational() {
      const obj = { 0: 'Balance', 1: 'Credit Card', 2: 'Paypal', 3: 'Airwallex', 6: 'Credit', 8: '40Seas', 9: 'Payoneer' }
      if (this.pays) {
        return obj[this.pays.paymentMethod]
      }
      return '-'
    },
    detailObj() {
      return {
        times: this.times,
        address: this.address,
        orders: this.orders,
        pays: this.pays,
        orderLogistics: this.orderLogistics
      }
    },
    getMoment() {
      return moment
    },
    refundText() {
      if (this.detailObj.orders.refundStatus !== 'NULL') {
        const statusMap = {
          refunding: 'Refunding',
          partial_refund: 'Partial Refund',
          refunded: 'Refunded'
        }
        return statusMap[this.detailObj.orders.refundStatus]
      }
      return ''
    },
    refundTextMap() {
      return {
        refunding: 'Refunding',
        partial_refund: 'Partial Refund',
        refunded: 'Refunded'
      }
    },
    showStatus() {
      if (['waiting_payment', 'completed', 'cancel'].includes(this.detailObj.orders.status)) return this.detailObj.orders.status
      if (this.detailObj.orders.status === 'abnormal_order') return this.detailObj.orders.financialStatus
      if (this.detailObj.orders.status === 'processing') return this.detailObj.orders.fulfillmentStatus
      return 'NULL'
      /*
        waiting_payment 待支付
        completed 已完成
        cancel 已取消
        waiting_to_ship 待发货
        fully_shipped 已发货
        partial_shipped  部分发货
      */
    }
  },
  created() {
    this.seeOrderDetails()
  },
  methods: {
    /**
     * API 获取优惠券和优惠码详情
     * 
     * @param {Object} parameter 请求参数
     */
    async getUserCouponTicketDetail(parameter) {
      let { data } = await API.getUserCouponTicketDetail(parameter)
      if (data) {
        this.coupon = data.couponTicket || {} // 优惠券
        this.promoCode = data.couponCode || {} // 优惠码
      }
    },

    /**
     * API 获取订单详情
     */
    async seeOrderDetails() {
      this.loading = true
      let { data } = await API.seeOrderDetails(this.$route.query.id, {})
      this.times = data.times
      this.address = data.address
      this.orders = data.orders
      this.pays = data.pays
      this.orderLogistics = data.orderLogistics
      // this.generateDate()
      this.loading = false
      this.getUserCouponTicketDetail({ userCouponTicketId: data.pays.couponTicketId, couponCode: data.pays.couponCode })
    },

    async incomeStatement() {
      this.dialogVisible = true
      let { data } = await API.queryIncomeCertificate(this.$route.query.id)
      this.tableData = data
    },

    closeDialog() {
      this.dialogVisible = false
    },
    showTrackingDialog(item) {
      this.$refs.trackingDialog.show(item)
    },
    packageWeight(pack) {
      return pack
        .reduce((current, next) => {
          return current + next.weight * next.productNum
        }, 0)
        .toFixed(2)
    },
    confirmReceipt(item) {},
    handleRefund() {
      this.$router.push(`/orders/all-orders/order-refund?kakaOrderId=${this.$route.query.id}`)
    }
  }
}
</script>

<style lang="scss" scoped>
.choose-to-use {
  display: flex;
  width: 317px;
  height: 32px;
  margin: 0 auto;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  border: 1px solid #e3444e;
  background: rgba(227, 68, 78, 0.03);
  .icon-youhuiquan {
    color: #E3444E;
    font-size: 20px;
  }
  .get-info {
    margin-left: 5px;
    .get {
      color: #10141D;
    }
    .discount {
      color: #E3444E;
    }
  }
}

.coupon-item {
  margin-bottom: 12px;
  &:last-child {
    margin-bottom: 0;
  }
}

.used-tips {
  color: #8B93A3;
  margin-bottom: 5px;
}

.el-icon-s-ticket {
  color: #E3444E;
  margin-left: 5px;
  cursor: pointer;
}

.details-container {
  height: 100%;
  font-size: 14px;

  .header {
    display: flex;
    height: 138px;
    padding: 12px;
    background-color: #fff;
    .left {
      width: 380px;
      padding-right: 12px;
      .title {
        display: block;
        font-size: 20px;
        line-height: 100px;
        text-align: center;
      }
    }
    .right {
      flex: 1;
      padding-left: 12px;
      p {
        margin-bottom: 10px;
      }
    }
  }

  .summary {
    display: flex;
    padding: 18px;
    align-items: center;
    justify-content: space-between;
    .income-statement {
      color: #f4a963;
      user-select: none;
      cursor: pointer;
    }
  }

  .subject {
    .left {
      float: left;
      width: calc(100% - 398px - 12px);
      max-height: calc(100vh - 258px);
      overflow: auto;
      .productItemGroup {
        min-width: 680px;
        padding: 15px 25px 0;
        // flex: 1;
        font-size: 18px;
        margin-bottom: 10px;
        .productItem {
          min-width: 770px;
          height: 130px;
          padding-bottom: 10px;
          .skuInfo {
            font-size: 14px;
          }
          .itemPrice {
            position: relative;
            font-size: 16px;
            margin-left: 15%;
            flex-shrink: 0;
            // font-weight: bold;
            > div {
              font-size: 12px;
              color: gray;
              text-decoration: line-through;
            }
          }
        }
        .weightTotal {
          height: 70px;
          line-height: 70px;
          border-top: 1px solid #cdd4dd;
        }
        .shipping_soon {
          h3 {
            margin-bottom: 4px;
          }
          .info {
            margin-bottom: 4px;
            .code {
              font-size: 14px;
              color: #747a87;
              margin-right: 8px;
            }
          }
        }
        .packStatus {
          font-size: 14px;
          color: #99c41c;
        }
        .packStatus::before {
          content: '';
          display: block;
          margin-right: 4px;
          width: 8px;
          height: 8px;
          line-height: 28px;
          border-radius: 100%;
          background-color: #99c41c;
        }
        .shippedInfomation {
          margin-bottom: 20px;
          > div {
            > div {
              font-size: 14px;
              margin-right: 10px;
            }
          }
        }
        .packStatis_complete {
          background: #f0f3e9;
          border-radius: 30px;
          color: #99c41c;
          padding: 6px 20px;
          display: inline-block;
        }
      }
    }
    .right {
      float: right;
      width: 398px;
      margin-left: 12px;
      .remark {
        padding: 12px;
        margin-bottom: 12px;
        background-color: #fff;
        .remark-describe {
          font-size: 16px;
          margin-bottom: 6px;
        }
      }
      .order-status {
        padding: 12px;
        margin-bottom: 12px;
        background-color: #fff;
        .status {
          font-size: 16px;
          margin-bottom: 16px;
        }
        .balance {
          font-size: 500;
        }
        .payment {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-top: 16px;
          .payment-left {
            color: #7d838f;
          }
          .payment-right {
            font-weight: 700;
          }
        }

        .promo {
          display: flex;
          align-items: center;
          justify-content: space-between;
        }
      }
      .shipping-address {
        padding: 12px;
        background-color: #fff;
        .shipping {
          font-size: 16px;
          margin-bottom: 16px;
        }
        div {
          color: #7d838f;
        }
      }
    }
  }
}

.image {
  display: flex;
  .image-item {
    width: 60px;
    height: 68px;
    overflow: hidden;
    margin-right: 6px;
    border: 1px solid #eceff2;
    border-radius: 4px;
    .el-image {
      width: 100%;
      object-fit: cover;
      vertical-align: middle;
      cursor: pointer;
    }
  }
  .options {
    width: 180px;
  }
}

.ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ellipsis2 {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}
.soldOutLabel {
  display: inline-block;
  width: 62px;
  height: 17px;
  font-weight: 400;
  font-size: 12px;
  text-align: center;
  line-height: 17px;
  color: #828282;
  background: #d9d9d9;
  border-radius: 2px;
}
.refund_reason {
  margin-bottom: 12px;
  padding: 14px 30px 14px 60px;
}
.refundStatus::before {
  content: '';
  display: block;
  margin-right: 4px;
  width: 8px;
  height: 8px;
  line-height: 28px;
  border-radius: 100%;
  background-color: #e53353;
}
.refundStatus {
  color: #e53353;
  font-size: 14px;
  font-weight: 400;
}
</style>

<style lang="scss">
.partsTable {
  font-family: 'Poppins';
  font-size: 14px;
  > p {
    margin-bottom: 14px;
    font-weight: bold;
  }
  .productBox {
    margin-bottom: 12px;
    .imageBox {
      margin-right: 12px;
    }
    // .info {
    // }
  }
}
.myAttachmentIcon:hover {
  background-color: #ffffff;
}
</style>
